// src/api/client.js

const REGION_MAP = {
  // --- AMERICAS ---
  'US': 'AMERICAS', 'CA': 'AMERICAS', 'MX': 'AMERICAS', 'BR': 'AMERICAS', 
  'AR': 'AMERICAS', 'BO': 'AMERICAS', 'CL': 'AMERICAS', 'CO': 'AMERICAS',
  'CR': 'AMERICAS', 'EC': 'AMERICAS', 'GT': 'AMERICAS', 'HN': 'AMERICAS',
  'NI': 'AMERICAS', 'PA': 'AMERICAS', 'PE': 'AMERICAS', 'PY': 'AMERICAS',
  'SV': 'AMERICAS', 'UY': 'AMERICAS',

  // --- EUROPE ---
  'GB': 'EUROPE', 'FR': 'EUROPE', 'DE': 'EUROPE', 'IT': 'EUROPE', 'ES': 'EUROPE',
  'AE': 'EUROPE', 'SA': 'EUROPE', 'KW': 'EUROPE', 'QA': 'EUROPE', 'BH': 'EUROPE',
  'OM': 'EUROPE', 'LB': 'EUROPE', 'TR': 'EUROPE', 'RU': 'EUROPE', 'ZA': 'EUROPE',
  'IE': 'EUROPE', 'PT': 'EUROPE', 'NL': 'EUROPE', 'BE': 'EUROPE', 'AT': 'EUROPE',
  'CH': 'EUROPE', 'SE': 'EUROPE', 'NO': 'EUROPE', 'DK': 'EUROPE', 'FI': 'EUROPE',
  'PL': 'EUROPE', 'UA': 'EUROPE', 'IN': 'EUROPE', 'MT': 'EUROPE', 'LU': 'EUROPE',

  // --- ASIA ---
  'HK': 'ASIA', 'TW': 'ASIA', 'KR': 'ASIA', 'SG': 'ASIA', 'MY': 'ASIA',

  // --- JAPAN ---
  'JP': 'JAPAN',

  // --- OCEANIA ---
  'AU': 'OCEANIA', 'NZ': 'OCEANIA'
};

export const fetchProductsLocal = async ({ region, platform }) => {
  
  const folderRegion = REGION_MAP[region] || 'AMERICAS';
  const fileName = `${region}_avatars.json`; 
  const filePath = `/Avatars/${folderRegion}/${platform}/${fileName}`;

  console.log(` Seeking: ${filePath}`);

  try {
    const response = await fetch(filePath, { cache: 'no-store' });
    
    if (!response.ok) {
      console.warn(` Missing File: ${filePath}`);
      return [];
    }

    const data = await response.json();
    console.log(` FOUND: ${data.length} items in ${fileName}`);
    
    return data.map((item, index) => {

      const id = item.avatar_id || item.contentId || item.id || `loc-${index}`;
      const name = item.name || item.title || 'Unknown Asset';
      
      
      let image = item.image_url || item.img || item.url;
      if (image && image.startsWith('http://')) {
        image = image.replace('http://', 'https://');
      }
      
      return {
        id: id,
        name: name,
        image: image,
        sku: id,
        price: item.price || 'N/A',
        titleId: item.title_id || item.titleId || 'N/A',
        originalData: item 
      };
    });

  } catch (error) {
    console.error(` Error loading ${filePath}:`, error);
    return []; 
  }
};